import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThinkingTalentsReportUser } from './thinking-talents-report-user';
import { Disclaimers } from '../common';
import { ModalLockedAssessment } from '../common/locks';
import { pdfsActions } from '../../../core/pdfs';

const Report = ({ user, view_mode, hanndleNextQuestion}) => {
    const dispatch = useDispatch();
    const [openLockedModal, setOpenLockedModal] = useState(false);
    const btnText = useRef('Next');

    const getFullReportTT = () => {
      dispatch(pdfsActions.loadFullReportTT());
    }

    return (
        <>
          <div>
            <div className='mb-3 pt-md-4'>
              <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Thinking Talents</h1>
              <p>Your Thinking Talents are your innate ways of thinking. Thinking Talents are the specific ways of approaching challenges that energize your brain and come naturally to you. These are different from the skills you develop through education and training. There are thirty-five Thinking Talents in all, and most adults naturally use 5-8. Not only do you lean into these talents, but when you think this way you feel energized. Here's how your Thinking Talents plot to Domains of Competence, which are four broad categories of thinking:</p>
            </div>

            <div className='p-md-3 border-md rounded'>
              { !view_mode && 
                <div className="mb-3">
                    <ThinkingTalentsReportUser />
                </div>
              }
              <div className="justify-content-center d-flex">
                { user && user.access_pdf_tt &&
                      <button onClick={() => getFullReportTT()} className="btn btn-green-light btn-sm mx-2">
                          <i className="mr-1">
                              <svg className='d-inline-block mb-1' xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="11" width="11" viewBox="0 0 10.94 10.94">
                                  <path d="M10.94,6.78v3.5c0,.17-.07,.34-.19,.46-.12,.12-.29,.19-.46,.19H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46v-3.5c0-.17,.07-.34,.19-.46,.12-.12,.29-.19,.46-.19s.34,.07,.46,.19c.12,.12,.19,.29,.19,.46v2.84H9.62v-2.84c0-.17,.07-.34,.19-.46,.12-.12,.29-.19,.46-.19s.34,.07,.46,.19c.12,.12,.19,.29,.19,.46Zm-5.93,.46c.06,.06,.13,.11,.21,.14,.08,.03,.17,.05,.25,.05s.17-.02,.25-.05,.15-.08,.21-.14l2.19-2.19c.12-.12,.19-.29,.19-.46s-.07-.34-.19-.46c-.12-.12-.29-.19-.46-.19s-.34,.07-.46,.19l-1.07,1.07V.66c0-.17-.07-.34-.19-.46-.12-.12-.29-.19-.46-.19s-.34,.07-.46,.19c-.12,.12-.19,.29-.19,.46V5.2l-1.07-1.07c-.06-.06-.13-.11-.21-.14-.08-.03-.17-.05-.25-.05-.17,0-.34,.07-.46,.19-.06,.06-.11,.13-.14,.21-.03,.08-.05,.17-.05,.25,0,.17,.07,.34,.19,.46l2.19,2.19Z"/>
                              </svg>
                          </i>Thinking Talent Report
                      </button>
                  }
                  { !view_mode &&
                    <>
                        <button className={`btn btn-sm btn-outline-green-light mx-2 ${user?.has_tt_blocked ? 'disabled' : ''}`} onClick={() => { user?.has_tt_blocked ? setOpenLockedModal(true) : hanndleNextQuestion('result_1')}}>
                          <i className="mr-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                            </svg>
                          </i>Review / Rearrange
                        </button>
                        <ModalLockedAssessment 
                          isOpen={openLockedModal}  
                          close={() => setOpenLockedModal(false)}
                          blockDays={user?.assessments_block_days}
                        />
                    </>
                  }

                    {false &&
                      <button className="btn btn-sm btn-green-light mx-2">{btnText.current}</button>
                    }
              </div>
            </div>
            <Disclaimers view="copyright" />
          </div>

        </>
    )
}
export default Report;
